// test1952
(1952 && 0);
